module.exports = __webpack_public_path__ + "static/media/play_again_button.1ad787a6.png";